var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('rfl-form',{attrs:{"presumptiveDataEach":_vm.referPresumptiveDataEach},on:{"emitForm":_vm.submitForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }